import Herosection from "../components/Events/Herosection";
import AllEvents from "../components/Events/Event";
import Loader from "../components/utils/Loader";
import { useEvents } from "../hooks/useEvent";

const Eventspage = () => {
  const { data:events, isLoading,isError, error } = useEvents();
  if (isLoading) return <Loader />;
  return (
    <div className="w-full flex flex-col items-center gap-10 md:gap-[72px]">
      <Herosection />
      {/* <Events /> */}
      <AllEvents/>
    </div>
  );
};

export default Eventspage;
